<template>
  <div class="row">
    <div class="col-lg-12">
      <a-form :form="form" @submit="handleSubmit">
        <div class="row justify-content-center">
          <div class="card col-8">
            <div class="card-header" v-if="!$route.params.id">
              <strong>Add Voucher</strong>
            </div>
            <div class="card-body">
              <a-form-item label="Voucher Code" class="col-lg-12 mr-2 ml-2" help="Customer will enter this discount code at checkout">
                <a-input
                  v-decorator="['code', {
                    rules: [{
                      required: true,
                      message: 'Please input your voucher code!'
                    }],
                    initialValue: value && value.voucher_code
                  }]"
                  placeholder="e.g. PROMO-KEMERDEKAAN"
                  v-if="!$route.params.id"
                />
                <div v-if="$route.params.id">
                  <strong> {{ value.voucher_code }} </strong>
                </div>
              </a-form-item>
            </div>
          </div>
          <div class="card col-8">
            <div class="card-body">
              <div>
                <a-form-item label="Channel" class="col-lg-12 mr-2 ml-2" has-feedback>
                  <a-select
                    v-decorator="['channel_id', {
                      rules: [{
                        required: true,
                        message: 'Please select channel!'
                      }],
                      initialValue: value && value.channel_id
                    }]"
                    placeholder="Select Channel"
                  >
                    <a-select-option v-for="(item, index) in channels" :key="index" :value="item.channel_id">
                      {{ item.channel_name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
            </div>
          </div>
          <div class="card col-8">
            <div class="card-body">
              <div>
                <a-form-item label="Voucher Type" class="col-lg-12 mr-2 ml-2" has-feedback>
                  <a-select
                    v-decorator="['type_id', {
                      rules: [{
                        required: true,
                        message: 'Please select your voucher type!'
                      }],
                      initialValue: value && value.type_id
                    }]"
                    placeholder="Select Voucher Type"
                    v-if="!$route.params.id"
                  >
                    <a-select-option :value="1">
                      Transaction Voucher
                    </a-select-option>
                    <a-select-option :value="2">
                      Product Item Voucher
                    </a-select-option>
                    <a-select-option :value="3">
                      Shipping Voucher
                    </a-select-option>
                    <a-select-option :value="4">
                      Voucher Brand
                    </a-select-option>
                  </a-select>
                  <div v-if="$route.params.id">
                    <strong> {{ typeVoucher(value.type_id) }} </strong>
                  </div>
                </a-form-item>
              </div>
              <div class="ml-2" v-if="form.getFieldValue('type_id') === 2 || (value && value.type_id === 2)">
                <a-form-item label="Select Products to Get Voucher" has-feddback>
                  <a-select
                    show-search
                    v-decorator="[
                      'product_list',
                      {
                        rules: [{
                          required: true,
                          message: 'Please select your products!',
                          type: 'array'
                        }],
                        initialValue: value && value.reference_list && initialValueProduct
                      },
                    ]"
                    mode="multiple"
                    placeholder="Select Product"
                  >
                    <a-select-option :value="product.product_title+'_'+index" v-for="(product, index) in productList" :key="index">
                      {{ product.product_title }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
              <div class="ml-2" v-if="form.getFieldValue('type_id') === 3 || (value && value.type_id === 3)">
                <a-form-item label="Select Courier">
                  <a-select
                    show-search
                    v-decorator="[
                      'courier_list',
                      {
                        rules: [{
                          required: true,
                          message: 'Please select courier',
                          type: 'array'
                        }],
                        initialValue: value && value.courier_list && inititalValueCourier
                      },
                    ]"
                    mode="multiple"
                    placeholder="Select Courier"
                  >
                    <a-select-option :value="courier.label" v-for="(courier, index) in courierList" :key="index">
                      {{ courier.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
              <div class="ml-2" v-if="form.getFieldValue('type_id') === 4 || (value && value.type_id === 4)">
                <a-form-item label="Select Brands" has-feddback>
                  <a-select
                    show-search
                    v-decorator="['brand_list', {
                      rules: [{
                        required: true,
                      }],
                      initialValue: value && value.reference_list && initialValueBrand
                    }]"
                    placeholder="Select Brand"
                  >
                    <a-select-option :value="`${brand.brand_title}_${index}`" v-for="(brand, index) in brands" :key="index">
                      {{ brand.brand_title }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
            </div>
          </div>
          <div class="card col-8">
            <div class="card-body">
              <div>
                <a-form-item label="Discount Type">
                  <a-radio-group v-decorator="['discount_type', {
                    rules: [{
                      required: true,
                      message: 'Please select discount type'
                      }],
                      initialValue: value && value.transaction_data && (form.getFieldValue('type_id') !== 3) ? value.transaction_data.type : form.getFieldValue('type_id') === 3 && 2
                    }]"
                  >
                    <a-radio :value="1" v-if="(form.getFieldValue('type_id') && form.getFieldValue('type_id') !== 3 ) || (value && value.type_id !== 3)">
                      Percentage
                    </a-radio>
                    <a-radio :value="2">
                      Fixed Amount
                    </a-radio>
                  </a-radio-group>
                </a-form-item>
              </div>
              <div>
                <a-form-item label="Discount Value" class="col-lg-4" v-if="form.getFieldValue('discount_type') === 1 || (value && value.transaction_data && value.transaction_data.type === 1)">
                  <a-input
                    v-decorator="['discount_value', {
                      rules: [{
                        required: true,
                        pattern: new RegExp('^[0-9]*$'),
                        message: 'Discount value must be a number'
                      }],
                      initialValue: value && value.transaction_data && value.transaction_data.value
                    }]"
                    addon-after="%"
                  />
                </a-form-item>
                <a-form-item label="Discount Value" class="col-lg-4" v-if="form.getFieldValue('type_id') === 3 || form.getFieldValue('discount_type') === 2 || (value && value.transaction_data && value.transaction_data.type === 2)">
                  <a-input
                    v-decorator="['discount_value', {
                      rules: [{
                        required: true,
                        pattern: new RegExp('^[0-9]*$'),
                        message: 'Discount value must be a number'
                      }],
                      initialValue: value && value.transaction_data && value.transaction_data.value
                    }]"
                    addon-before="IDR"
                  />
                </a-form-item>
              </div>
            </div>
          </div>
          <div class="card col-8">
            <div class="card-body">
              <div>
                <a-form-item label="Quantity Voucher" class="col-lg-4">
                  <a-input
                    v-decorator="['qty', {
                      rules: [{
                        required: true,
                        pattern: new RegExp('^[0-9]*$'),
                        message: 'Quantity value must be a number'
                      }],
                      initialValue: value && value.qty
                    }]"
                  />
                </a-form-item>
              </div>
              <div>
                <a-form-item label="Minimum Transcation" class="col-lg-4">
                  <a-input
                    v-decorator="['min_transaction', {
                      rules: [{
                        required: true,
                        pattern: new RegExp('^[0-9]*$'),
                        message: 'Minimum transaction must be a number'
                      }],
                      initialValue: value && value.transaction_data && value.transaction_data.min_transaction
                    }]"
                    addon-before="IDR"
                  />
                </a-form-item>
              </div>
              <div>
                <a-form-item label="Maximum Discount" class="col-lg-4">
                  <a-input
                    v-decorator="['max_discount', {
                      rules: [{
                        required: true,
                        pattern: new RegExp('^[0-9]*$'),
                        message: 'Maximum Discount must be a number'
                      }, form.getFieldValue('discount_type') === 2 && max_discount],
                      initialValue: (form.getFieldValue('discount_type') === 2 && form.getFieldValue('discount_value') ? Number(form.getFieldValue('discount_value')) : null) || (value && value.transaction_data && value.transaction_data.max_discount.toString())
                    }]"
                    addon-before="IDR"
                  />
                </a-form-item>
              </div>
            </div>
          </div>
          <div class="card col-8">
            <div class="card-body">
              <div>
                <a-form-item label="Voucher can combined ?" >
                  <a-radio-group
                    v-decorator="['f_combined', {
                      rules: [{
                        required: true,
                        message: 'Please check this option'
                      }],
                      initialValue: value && value.f_combined
                    }]"
                  >
                    <a-radio :value="true">
                      Yes
                    </a-radio>
                    <a-radio :value="false">
                      No
                    </a-radio>
                  </a-radio-group>
                </a-form-item>
              </div>
            </div>
          </div>
          <div class="card col-8">
            <div class="card-body">
              <div>
                <a-form-item label="Set Voucher To All Store" >
                  <a-radio-group
                    v-decorator="['f_allstore', {
                      rules: [{
                        required: true,
                        message: 'Please check this option'
                      }],
                      initialValue: value && value.f_allstore
                    }]"
                  >
                    <a-radio :value="true">
                      Yes
                    </a-radio>
                    <a-radio :value="false">
                      No
                    </a-radio>
                  </a-radio-group>
                </a-form-item>
              </div>
              <div>
                <div class="ml-2" v-if="form.getFieldValue('f_allstore') === false || (value && value.f_allstore === false)">
                  <a-form-item label="Select Stores to Get Voucher" has-feddback>
                    <a-select
                      v-decorator="['store_list', {
                        rules: [{
                          required: true,
                          message: 'Please select store list', type: 'array'
                        }],
                        initialValue: value && value.store_list && initialValueReseller
                      }]"
                      mode="multiple"
                      placeholder="Select Store"
                    >
                      <a-select-option :value="reseller.store_name" v-for="reseller in resellerList" :key="reseller.seller_hashid">
                        {{ reseller.store_name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </div>
              </div>
            </div>
          </div>
          <div class="card col-8">
            <div class="card-body">
              <div>
                <a-form-item label="Voucher periode" class="ml-2">
                  <!-- <a-range-picker v-decorator="['validity', rangeConfig]" /> -->
                  <a-date-picker
                    v-model="startValue"
                    :disabled-date="disabledStartDate"
                    show-time
                    format="YYYY-MM-DD HH:mm:ss"
                    placeholder="Start"
                    @openChange="handleStartOpenChange"
                    class="mr-2"
                    :disabled="disabledStartValue"
                  />
                  <a-date-picker
                    v-model="endValue"
                    :disabled-date="disabledEndDate"
                    show-time
                    format="YYYY-MM-DD HH:mm:ss"
                    placeholder="End"
                    :open="endOpen"
                    @openChange="handleEndOpenChange"
                    class="ml-2"
                    :disabled="disabledEndValue"
                  />
                </a-form-item>
              </div>
              <div>
                <a-form-item class="ml-2">
                  <a-button type="primary" html-type="submit">
                    Submit
                  </a-button>
                </a-form-item>
              </div>
            </div>
          </div>
        </div>
      </a-form>
    </div>
    <div class="vld-parent">
      <loading
        :active.sync="isLoadingDiscount"
        :can-cancel="false"
        :is-full-page="fullPage"
        :height="30"
        :width="30"
      ></loading>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Loading from 'vue-loading-overlay'
import moment from 'moment'

export default {
  props: {
    value: {
      type: Object,
    },
    statusVoucher: {
      type: String,
    },
  },
  components: {
    Loading,
  },
  data () {
    return {
      isAllStore: true,
      isDiscountProduct: false,
      isAllProduct: true,
      isAbsolute: false,
      isPercentage: false,
      fullPage: true,
      rangeConfig: {
        rules: [{
          type: 'array',
          required: true,
          message: 'Please select time!',
        }],
        initialValue: null,
      },
      showModalProduct: false,
      form: this.$form.createForm(this),
      max_discount: {
        validator: (rule, value, callback) => {
          if (+value > +this.form.getFieldValue('discount_value')) {
            // eslint-disable-next-line standard/no-callback-literal
            callback('maximum discount cant be greater than the discounted value')
          } else if (+value < +this.form.getFieldValue('discount_value')) {
            // eslint-disable-next-line standard/no-callback-literal
            callback('maximum discount cant be less than the discounted value')
          } else {
            callback()
          }
        },
      },
      initialValueProduct: [],
      initialValueBrand: [],
      initialValueReseller: [],
      inititalValueCourier: [],
      startValue: null,
      endValue: null,
      endOpen: false,
      disabledStartValue: false,
      disabledEndValue: false,
    }
  },
  mounted () {
    this.$store.dispatch('discounts/getProductList')
    this.$store.dispatch('discounts/getBrands')
    this.$store.dispatch('discounts/GETCOURIERLIST')
    this.$store.dispatch('channel/getChannels')
  },
  computed: {
    ...mapState('discounts', {
      productList: state => state.productList,
      resellerList: state => state.resellerList,
      courierList: state => state.courierList,
      isLoadingDiscount: state => state.isLoadingDiscount,
      brands: state => state.brands,
    }),
    ...mapState('channel', {
      channels: state => state.list,
    }),
  },
  methods: {
    ...mapActions('discounts', ['getProductList', 'addDiscountCode']),

    handleSubmit (e) {
      e.preventDefault()
      if (!this.startValue || !this.endValue) {
        return this.$notification.error({
          message: 'Please input a voucher periode',
        })
      }
      const validity = [this.startValue, this.endValue]
      if (this.$route.params.id) {
        this.form.validateFieldsAndScroll((err, values) => {
          if (err) return
          this.$store.dispatch('discounts/EDITVOUCHER', {
            uuid: this.$route.params.id,
            type_id: this.value.type_id,
            code: this.value.voucher_code,
            validity,
            ...values,
          })
        })
      } else {
        this.form.validateFieldsAndScroll((err, values) => {
          if (err) return
          this.$store.dispatch('discounts/addDiscountCode', {
            validity,
            ...values,
          })
        })
      }
    },

    typeVoucher (value) {
      switch (value) {
        case 1:
          return 'Transaction Voucher'

        case 2:
          return 'Product Item Voucher'

        case 3:
          return 'Shipping Voucher'

        case 4:
          return 'Voucher Brand'

        default:
          break
      }
    },

    showModal () {
      this.showModalProduct = true
    },

    disabledStartDate(startValue) {
      const endValue = this.endValue
      if (!startValue || !endValue) {
        return false
      }
      return (startValue.valueOf() > endValue.valueOf() || this.statusVoucher === 'running')
    },
    disabledEndDate(endValue) {
      const startValue = this.startValue
      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open
    },
  },
  watch: {
    value: function (newVal) {
      const fromDate = moment(this.value.validity.from * 1000).format('YYYY-MM-DD HH:mm:ss')
      const untilDate = moment(this.value.validity.until * 1000).format('YYYY-MM-DD HH:mm:ss')
      this.startValue = moment(fromDate, 'YYYY-MM-DD HH:mm:ss')
      this.endValue = moment(untilDate, 'YYYY-MM-DD HH:mm:ss')

      if (this.value.type_id === 2) {
        const result = []
        this.productList.map((product, index) => {
          this.value.reference_list.find(item => {
            if (item === product.uuid) {
              result.push(`${product.product_title}_${index}`)
            }
          })
        })
        this.initialValueProduct = result
      }

      if (this.value.type_id === 3) {
        const result = []
        this.courierList.map((courier) => {
          this.value.courier_list.find(item => {
            if (item === courier.value) {
              result.push(courier.label)
            }
          })
        })
        this.inititalValueCourier = result
      }

      if (this.value.type_id === 4) {
        const result = []
        this.brands.map((brand, index) => {
          this.value.reference_list.find(item => {
            if (item === brand.uuid) {
              result.push(`${brand.brand_title}_${index}`)
            }
          })
        })
        this.initialValueBrand = result
      }

      if (!this.value.f_allstore) {
        this.value.store_list.map(item => {
          this.initialValueReseller.push(item.label)
        })
      }
    },
    statusVoucher: function (newVal) {
      if (newVal === 'running') {
        this.disabledStartValue = true
      }
    },
  },
}
</script>
